import React from 'react';

import { useMutation } from '@tanstack/react-query';

import FormContainer from '../../../../FormContainer';

import useReversePaymentForm from '../../../../../../forms/loan/reversePayment';
import PaymentService from '../../../../../../services/PaymentService';
import { useUiContext } from '../../../../../../context/UiContext';

export default function ReversePaymentForm({
  refetch,
  paymentId,
  isDistributed,
}) {
  const { showToast } = useUiContext();

  const { mutate: reversePayment, isPending } = useMutation({
    mutationFn: (formValues) =>
      PaymentService.reversePayment({
        paymentId,
        formValues,
      }),
    onSuccess: () => {
      refetch();
      showToast({
        text: 'Payment reversed successfully',
        type: 'success',
      });
    },
    onError: (error) => {
      console.log(error);
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    },
  });

  const form = useReversePaymentForm(reversePayment, isDistributed);

  return (
    <div>
      <h2
        className={`text-2xl text-slate-800 dark:text-slate-100 font-bold flex justify-between w-full ${
          !isDistributed ? 'mb-6' : 'mb-3'
        }`}
      >
        Reverse Payment
      </h2>
      {isDistributed && (
        <p className="mb-6">
          This payment has already been distributed and cannot be reversed. To
          reverse the payment, first delete the bills where the payment was
          distributed.
        </p>
      )}
      {!isDistributed && (
        <FormContainer
          form={form}
          noBillComId
          isSubmitting={isPending}
          noTitle
          titleStyle="!mb-0"
        />
      )}
    </div>
  );
}
